<article class="page-container flex flex-column">
  <section class="pb-2">
    <button pButton icon="fas fa-plus" class="p-button-info p-button-outlined" [pTooltip]="screen.actions.add"
      (click)="openModal()">
    </button>
  </section>

  <p-accordion styleClass="hide-from-small pb-2 accordion__tab--no-margin" expandIcon="far fa-eye"
    collapseIcon="far fa-eye-slash">
    <p-accordionTab class="m-0" [header]="screen.labels.filters">
      <label for="dtMobileDocumentFilter">{{screen.labels.document}}</label>
      <div>
        <input pInputText type="text" name="dtMobileDocumentFilter" [(ngModel)]="dtDocumentFilter"
          (input)="dt.filter(dtDocumentFilter, 'document', 'contains')" validation>
      </div>

      <label for="dtMobileNameFilter">{{screen.labels.name}}</label>
      <div>
        <input pInputText type="text" name="dtMobileNameFilter" [(ngModel)]="dtNameFilter"
          (input)="dt.filter(dtNameFilter, 'fullName', 'contains')" validation>
      </div>
    </p-accordionTab>
  </p-accordion>

  <section class="inline-flex">
    <p-table #dt [value]="doctors.content" [lazy]="true" (onLazyLoad)="lazyReadDoctors($event)" [paginator]="true"
      [rows]="pageSize" [totalRecords]="doctors.totalElements" [loading]="loading" dataKey="id" [contextMenu]="cm"
      [(contextMenuSelection)]="selectedDoctor" (onContextMenuSelect)="setContextMenuItems()" class="col-12 p-0">

      <ng-template pTemplate="colgroup" let-columns>
        <colgroup class="hide-on-small">
          <col data-id="expander" [style.width.px]="50">
          <col data-id="status" [style.width.px]="50">
          <col data-id="documentType" [style.width.px]="125">
          <col data-id="document" [style.width.px]="175">
          <col data-id="name">
          <col data-id="username" [style.width.px]="200" class="hide-on-medium">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th [attr.colspan]="2" [attr.rowspan]="2"></th>
          <th [attr.colspan]="2" class="text-center">{{screen.labels.document}}</th>
          <th class="text-center">{{screen.labels.name}}</th>
          <th class="text-center hide-on-medium" [attr.rowspan]="2">{{screen.labels.username}}</th>
        </tr>
        <tr>
          <th [attr.colspan]="2">
            <input pInputText type="text" name="dtDocumentFilter" [(ngModel)]="dtDocumentFilter"
              (input)="dt.filter(dtDocumentFilter, 'document', 'contains')">
          </th>
          <th>
            <input pInputText type="text" name="dtNameFilter" [(ngModel)]="dtNameFilter"
              (input)="dt.filter(dtNameFilter, 'fullName', 'contains')">
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-doctor let-expanded="expanded">
        <tr [pContextMenuRow]="doctor">
          <td class="text-center pointer" [pRowToggler]="doctor">
            <i class="text-info fas" [ngClass]="{'fa-chevron-down': expanded, 'fa-chevron-right': !expanded}"></i>
          </td>
          <td class="text-center hide-on-small">
            <i class="fas fa-circle {{doctor.status ? 'text-success' : 'text-danger'}}"
              [pTooltip]="doctor.status ? screen.labels.enabled : screen.labels.disabled"></i>
          </td>
          <td>{{doctor.documentTypeName}}</td>
          <td>{{doctor.document}}</td>
          <td>{{doctor.fullName}}</td>
          <td class="hide-on-medium">{{doctor.username}}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="rowexpansion" let-doctor>
        <tr [pContextMenuRow]="doctor">
          <td class="hide-on-medium" [attr.colspan]="6">
            <ng-template *ngTemplateOutlet="expander; context: {$implicit: doctor}"></ng-template>
          </td>

          <td class="hide-from-medium" [attr.colspan]="5">
            <ng-template *ngTemplateOutlet="expander; context: {$implicit: doctor}"></ng-template>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="hide-on-medium" [attr.colspan]="6">
            <ng-template [ngTemplateOutlet]="datatableEmpty"></ng-template>
          </td>

          <td class="hide-from-medium" [attr.colspan]="5">
            <ng-template [ngTemplateOutlet]="datatableEmpty"></ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>

  <section class="align-self-end">
    <ms-table-paged-footer [page]="doctors"></ms-table-paged-footer>
  </section>

  <p-contextMenu #cm [model]="options"></p-contextMenu>

  <ng-template #expander let-doctor>
    <section class="flex flex-column">
      <div class="inline-flex flex-wrap">
        <span class="col-12 lg:col-4 px-0 inline-flex align-items-center justify-content-center">
          {{doctor.dateBorn}} - {{doctor.locationBornName}}
        </span>
        <span class="col-6 lg:col-4 px-0 inline-flex align-items-center justify-content-center">
          {{doctor.genderName}}
        </span>
        <span class="col-6 lg:col-4 px-0 inline-flex align-items-center justify-content-center">
          {{doctor.maritalStatusName}}
        </span>
      </div>

      <div class="inline-flex flex-wrap">
        <label class="col-fixed px-0 md:pr-2 inline-flex align-items-center p-m-0 field__label strong"
          [style.width.px]="210">{{screen.labels.senescyt}}</label>
        <span class="col px-0 md:px-2 inline-flex">
          {{doctor.senescyt}}
        </span>
        <label
          class="col-12 md:col-2 px-0 md:pr-2 inline-flex align-items-center p-m-0 field__label strong">{{screen.labels.quitclaim}}</label>
        <span class="col-12 md:col-4 px-0 md:pl-2 inline-flex">
          <span *ngIf="doctor.quitclaimDate">{{doctor.quitclaimDate | date:'dd-MM-yyyy'}}</span>
        </span>
      </div>

      <div class="inline-flex flex-wrap">
        <label
          class="col-12 md:col-2 px-0 md:pr-2 inline-flex align-items-start p-m-0 field__label strong">{{screen.labels.email}}</label>
        <span class="col-12 md:col-10 px-0 md:pl-2 inline-flex">
          <ms-string-split [toSplit]="doctor.email" [isEmail]="true"></ms-string-split>
        </span>
      </div>

      <div class="inline-flex flex-wrap">
        <label
          class="col-12 md:col-2 px-0 md:pr-2 inline-flex align-items-start p-m-0 field__label strong">{{screen.labels.phone}}</label>
        <span class="col-12 md:col-10 px-0 md:pl-2 inline-flex">
          <ms-string-split [toSplit]="doctor.phone" [isPhone]="true"></ms-string-split>
        </span>
      </div>

      <div class="inline-flex flex-wrap">
        <label
          class="col-12 md:col-2 px-0 md:pr-2 inline-flex align-items-start p-m-0 field__label strong">{{screen.labels.residence}}</label>
        <span class="col-12 md:col-10 px-0 md:pl-2 inline-flex">
          {{doctor.residenceName}} - {{doctor.address | uppercase}}
        </span>
      </div>

      <div class="inline-flex flex-wrap">
        <label
          class="col-12 md:col-2 px-0 md:pr-2 inline-flex align-items-start p-m-0 field__label strong">{{screen.labels.specialties}}</label>
        <span class="col-12 md:col-10 px-0 md:pl-2">
          <span class="form__field" *ngFor="let specialty of doctor.specialties">
            {{specialty.specialtyName}}
          </span>
        </span>
      </div>

      <div class="inline-flex flex-wrap hide-from-medium">
        <label
          class="col-12 md:col-2 px-0 md:pr-2 inline-flex align-items-start p-m-0 field__label strong">{{screen.labels.username}}</label>
        <span class="col-12 md:col-10 px-0 md:pl-2">
          {{doctor.username}}
        </span>
      </div>
    </section>
  </ng-template>

  <ng-template #datatableEmpty>
    <span>{{screen.labels.emptyTable}}</span>
  </ng-template>
</article>